'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import MaterialCardActions from '@mui/material/CardActions';
import { Divider } from '../Divider';
import { styled } from '@mui/material/styles';
import { excludeComponentProps } from '../utils/excludeComponentProps';
const StyledCardActions = styled(MaterialCardActions, {
    ...excludeComponentProps('justifyContent', 'dense')
})(({ theme, dense, bgcolor, justifyContent: justifyContentProp }) => ({
    padding: '1rem',
    ...dense && {
        padding: '.5rem'
    },
    ...justifyContentProp && {
        justifyContent: justifyContentProp
    },
    ...bgcolor && {
        backgroundColor: bgcolor
    },
    ...bgcolor === 'gray' && {
        backgroundColor: theme.tokens.FuelColorGray50
    }
}));
export const CardActions = React.forwardRef(({ dense = false, divider = 'none', bgcolor, justifyContent = 'flex-start', ...props }, ref) => (_jsxs(_Fragment, { children: [divider === 'top' && _jsx(Divider, {}), _jsx(StyledCardActions, { bgcolor: bgcolor, dense: dense, justifyContent: justifyContent, ref: ref, ...props }), divider === 'bottom' && _jsx(Divider, {})] })));
CardActions.displayName = 'CardActions';
